import { Record, List } from 'immutable';
import type { SavedFilterAPIResponse } from '~/ducks/machine-filter-v2/types/api-reponse-types';
import type { SavableFilterTypes } from '~/ducks/machine-filter-v2/types/filter-value-types';
import FilterDefinitionTypeConstants from '~/constants/filter-definition-type-constants';
import FilterDefinitionValueRecord from '~/ducks/machine-filter-v2/data/FilterDefinitionValueRecord';
import * as filterUtils from '../utils/filter-utils';
import {
  FreeTextFilterRecord,
  RangeFilterRecord,
  SelectFilterRecord,
  TagFilterRecord,
} from './filter-values';
import NameRecord from './NameRecord';

const keys: Fields = {
  id: '',
  name: '',
  favorite: false,
  filters: List(),
  isLoading: false,
};

export interface Fields {
  id: string;
  name: string;
  favorite: boolean;
  filters: List<SavableFilterTypes>;
  isLoading: boolean;
}

export default class SavedFilterRecord extends Record<Fields>(keys) {
  constructor(values?: SavedFilterAPIResponse) {
    super(values as any);

    const newValues: Partial<Fields> = {};
    if (values?.filters) {
      const filterRecords = values.filters
        .map((filter) => {
          const filterName = new NameRecord(filter.name);
          const obj = {
            filterName,
            ...filter,
          };

          switch (filter.type) {
            case FilterDefinitionTypeConstants.MULTI_SELECT_TAGS: {
              return new TagFilterRecord(obj);
            }

            case FilterDefinitionTypeConstants.MULTI_SELECT:
              return new SelectFilterRecord(obj);

            case FilterDefinitionTypeConstants.RANGE:
              return new RangeFilterRecord(obj);

            case FilterDefinitionTypeConstants.TEXT:
              return new FreeTextFilterRecord(obj);

            default:
              return undefined;
          }
        })
        .filter((f) => !!f);

      newValues.filters = List(filterRecords) as Fields['filters'];
    }
    return this.merge(newValues);
  }

  getId(): string {
    return this.id;
  }

  getName(): string {
    return this.name;
  }

  isFavorite(): boolean {
    return this.favorite;
  }

  getIsLoading(): boolean {
    return this.isLoading;
  }

  getFilters(): List<SavableFilterTypes> {
    return this.filters;
  }

  removeFilterValue(
    filterName: string,
    removeFilterValue?: FilterDefinitionValueRecord | 'min' | 'max'
  ): this {
    return filterUtils.removeFilterValue(this, filterName, removeFilterValue);
  }
}
